<template>
  <div :class="{ 'is-demo-visible': isDemoVisible }" class="logo-layout">
    <DemoBar :visible="isDemoVisible" />
    <!-- START NAV -->
    <nav class="navbar">
      <div class="container">
        <div class="navbar-brand">
          <a class="navbar-item logo-img" href="/">
            <img
              :src="require('@/assets/images/logo/primary.svg')"
              alt="Logo"
            />
          </a>
        </div>
      </div>
    </nav>
    <!-- END NAV -->
    <div class="body-inner">
      <keep-alive> <router-view :key="$route.fullPath" /> </keep-alive>
    </div>
    <Footer />
  </div>
</template>

<style lang="scss">
.logo-layout {
  .navbar {
    > .container {
      padding-bottom: 0 !important;
    }
  }

  .body-inner {
    min-height: 100vh;
    margin-top: -200px;
    padding-top: 200px;
  }

  &.is-demo-visible {
    .body-inner {
      margin-top: -280px !important;
      padding-top: 280px;
    }
  }
}

.logo-img {
  width: 130px;
  height: 80px;
}
.logo-img img {
  width: 100%;
  height: 100%;
}
.navbar-item img {
  max-height: none;
}
</style>

<script>
import { Component, Vue } from 'vue-property-decorator';
import Footer from '@/components/Footer';
import DemoBar from '@/components/DemoBar';

@Component({
  components: {
    Footer,
    DemoBar
  },
  data() {
    return {
      isDemoVisible: !this.$hideDemoBar
    };
  },
  computed: {
    language: function() {
      this.$i18n.locale = this.$route.query.lang ? this.$route.query.lang : 'ja';
      return this.$route.query.lang;
    }
  },
  watch: {
    language: function() {
      // return this.$route.query.lang;
    }
  }
})
export default class LogoFrame extends Vue {}
</script>
